import React, { Component } from 'react';

interface componentProps {
    title: string;
}

class DynamicTitleSection extends Component<componentProps,{}> {

    render() {

        const { title } = this.props;

        const DynamicTitle = () => {
            return(
                <span className="title-lg" title={title}>{title}</span>
            );
        }

        return <DynamicTitle />
    }
}

export default DynamicTitleSection;